/* globals jui, Class */
module.exports = Class.create(jui.ModalDialog, {
  close: function($super) {
    $super();
    this.fireEvent('closed');
  }
});



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/base_dialog.js